import { render } from "./OnlineCareRequestEdit.vue?vue&type=template&id=9b9dfbc4&scoped=true&ts=true"
import script from "./OnlineCareRequestEdit.vue?vue&type=script&lang=ts"
export * from "./OnlineCareRequestEdit.vue?vue&type=script&lang=ts"

import "./OnlineCareRequestEdit.vue?vue&type=style&index=0&id=9b9dfbc4&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9dfbc4"]])

export default __exports__